/**
 * TokenPurchaseCancelled
 *
 * Page displayed when user cancels token purchase.
 * Allows them to try again or return to the app.
 */

import { XCircle, RefreshCw, ArrowLeft } from 'lucide-react';

interface TokenPurchaseCancelledProps {
  onNavigateHome: () => void;
  onTryAgain: () => void;
}

export function TokenPurchaseCancelled({
  onNavigateHome,
  onTryAgain,
}: TokenPurchaseCancelledProps) {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-secondary-50 dark:bg-secondary-900">
      <div className="text-center max-w-md">
        {/* Cancelled icon */}
        <div className="relative mb-6">
          <div className="absolute inset-0 bg-secondary-500/20 rounded-full blur-xl" />
          <XCircle className="h-20 w-20 text-secondary-400 mx-auto relative" />
        </div>

        {/* Title */}
        <h1 className="text-2xl sm:text-3xl font-bold text-secondary-900 dark:text-white mb-3">
          Purchase Cancelled
        </h1>

        {/* Message */}
        <p className="text-secondary-600 dark:text-secondary-400 mb-8">
          Your payment was cancelled. No charges were made to your account.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={onTryAgain}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-lg font-medium transition-colors min-h-[44px]"
          >
            <RefreshCw className="h-5 w-5" />
            Try Again
          </button>

          <button
            onClick={onNavigateHome}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-secondary-100 dark:bg-secondary-800 hover:bg-secondary-200 dark:hover:bg-secondary-700 text-secondary-900 dark:text-white rounded-lg font-medium transition-colors min-h-[44px]"
          >
            <ArrowLeft className="h-5 w-5" />
            Back to App
          </button>
        </div>
      </div>
    </div>
  );
}
